import { Card, CardActions, CardContent, CardHeader } from 'maple-storybook'
import PropTypes from 'prop-types'

import 'variables/styles/regularCardStyle.css'

function RegularCard({
  headerColor,
  plainCard,
  cardTitle,
  cardTitleStyle,
  id,
  cardSubtitle,
  content,
  cardHeaderStyle,
  action,
  footer,
  cardContainer,
  cardSubtitleStyle,
  breadCrumbs,
  breadCrumbsContent,
  noPadding,
  userFormCard,
  ...rest
}) {
  const cardHeaderColor = headerColor ? headerColor : ''
  const plainCardClasses = plainCard ? 'card-plain' : ''
  const cardPlainHeaderClasses = plainCard ? 'card-plain-header' : ''
  const userFormCardClasses = userFormCard ? 'user-form-card' : ''

  return (
    <Card
      {...rest}
      className={`card ${userFormCardClasses} ${plainCardClasses} ${cardContainer}`}
      id={id && `${id}-card`}>
      {breadCrumbs && breadCrumbsContent}
      <CardHeader
        id={id && `${id}-card-header`}
        classes={{
          root: `card-header ${cardHeaderColor}-card-header ${cardPlainHeaderClasses}`,
          content: `${cardHeaderStyle ? cardHeaderStyle : ''}`,
          title: `${cardTitleStyle ? cardTitleStyle : 'card-title'}`,
          subheader: `${cardSubtitleStyle ? cardSubtitleStyle : 'card-subtitle'}`
        }}
        title={cardTitle}
        subheader={cardSubtitle}
        action={action}
      />
      <CardContent
        sx={noPadding ? { padding: '0px !important' } : { padding: '10px !important' }}
        id={id && `${id}-card-content`}>
        {content}
      </CardContent>
      {footer !== undefined && <CardActions className="card-actions">{footer}</CardActions>}
    </Card>
  )
}

RegularCard.defaultProps = {
  headerColor: 'blue'
}

RegularCard.propTypes = {
  plainCard: PropTypes.bool,
  headerColor: PropTypes.oneOf(['orange', 'green', 'red', 'blue', 'purple', 'dodgerblue']),
  cardTitle: PropTypes.node,
  cardSubtitle: PropTypes.node,
  content: PropTypes.node,
  action: PropTypes.node,
  footer: PropTypes.node
}

export default RegularCard
